import React from "react";
import { connect } from "react-redux";
import store from "../../../../Store";
import Loading from "../../../../components/shared/loaders/Loading";
import Select from "../../../../components/shared/form/ReactSelect";
import swal from "sweetalert";
import InternalMigration from "../../../../assets/images/internal-migration.svg";
import { withRouter } from "react-router";
import ServerMigrationWorker from "./ServerMigrationWorker";
import {
  onServerMigrationChange,
  onServerMigrationSubmit,
} from "./ServerMigration-Action";

class serverMigration extends React.Component {
  ServerMigrationSubmit = (e) => {
    e.preventDefault();
    swal("Are you sure you want to perform Live Migration?", {
      buttons: {
        cancel: "Cancel",
        catch: {
          text: "Yes",
          value: e,
        },
      },
    }).then((e) => {
      if (e) store.dispatch(onServerMigrationSubmit());
    });
  };

  onChange = (e) => {
    if (e === null) {
      store.dispatch(onServerMigrationChange("Server", ""));
    } else {
      store.dispatch(onServerMigrationChange(e.name, e.value));
    }
  };

  render() {
    let {
      errors,
      getSite,
      servers = [],
      site_status,
      credentials,
    } = this.props;
    let clearable = true;

    let serversList = [];
    if (servers?.length) {
      serversList = servers
        .filter(
          (server) =>
            credentials && server.public_ip_address !== credentials.sftp_host
        )
        .map((server) => ({
          value: server.id,
          label: server.name,
        }));
    }

    let { processing } = getSite.processing;

    return (
      <>
        <ServerMigrationWorker />
        <form className="mt-10" onSubmit={this.ServerMigrationSubmit}>
          <div className="padded-block">
            <div
              className="d-flex justify-content-between align-items-center col-md-12 px-0"
              id="form-block-section"
            >
              <div className="d-flex text-section">
                <img alt="logo" src={InternalMigration} />
                <div>
                  <p id="site-tools">Migration Tool</p>
                  <h3>Live Migrations</h3>
                </div>
              </div>
              <div className="d-flex justify-content-between px-0 input-and-button-section">
                <div className="px-0 input-section mr-5">
                  <Select
                    name="Server"
                    isClearable={clearable}
                    placeholder="Select Server"
                    value={serversList.id}
                    options={serversList}
                    onChange={this.onChange}
                    errors={errors && errors.server_id}
                    noFormGroup
                  />
                </div>
                <div className="button-wrapper ml-2">
                  <button
                    type="submit"
                    className="btn-theme btn-outline"
                    id="admin-org-btn"
                    disabled={
                      site_status === "pending" ||
                      site_status === "updating" ||
                      site_status === "migrating" ||
                      site_status === "restoring"
                        ? "disabled"
                        : null
                    }
                  >
                    {processing ? <Loading /> : `Submit`}
                  </button>
                </div>
              </div>
            </div>
            <div className="description-section mt-5">
              <p>
                Use the Live Migration tool to move a site from one Celestio
                server to another within the same DataCenter. Begin by selecting
                the destination server and clicking Submit. The Celestio system
                will automatically create a full backup of the site, perform the
                migration process, and restore the site onto the selected
                server.
              </p>
            </div>
          </div>
        </form>
      </>
    );
  }
}

function mapStateToProps(state) {
  let {
    serverMigrationForm,
    createServerMigration,
    getSite,
    getSiteStatus,
    siteDashboard,
    getServerModules,
    getCredentials,
  } = state;
  let { errors, payload } = serverMigrationForm.data;
  let { site_status } = siteDashboard.data;

  let servers = getServerModules?.success?.data?.data || [];

  let { server_id } = payload;

  const credentials = getCredentials && getCredentials.success;

  return {
    serverMigrationForm,
    server_id,
    errors,
    createServerMigration,
    getSite,
    getSiteStatus,
    credentials,
    siteDashboard,
    servers,
    site_status,
  };
}

export default withRouter(connect(mapStateToProps)(serverMigration));
